import React from 'react';

/**
 * Brand logo lockup:
 *  - PNG of wine glass + "Tour de Taste" wordmark (no underline / no tagline)
 *  - Bright yellow underline rendered in HTML for full color control
 *  - "Taste the World Differently." tagline as real HTML text, solid black, large
 *
 * Sizes are tuned via the `size` prop variants: 'sm' | 'md' | 'lg' | 'xl'
 * `tone` controls the tagline color so the same lockup works on dark backgrounds.
 */
export function Logo({ size = 'md', tone = 'dark', dropShadow = false, className = '' }) {
  const sizes = {
    // Mobile is now noticeably larger for readability; still scales up on lg
    sm: { img: 'h-14 sm:h-16 lg:h-20', tag: 'text-sm sm:text-base lg:text-base', rule: 'h-[1.5px]', gapTop: 'mt-2', gapTag: 'mt-1.5' },
    md: { img: 'h-20 sm:h-24 lg:h-28', tag: 'text-base sm:text-lg lg:text-xl', rule: 'h-[1.5px]', gapTop: 'mt-2 sm:mt-3', gapTag: 'mt-2' },
    lg: { img: 'h-24 sm:h-32 lg:h-36', tag: 'text-lg sm:text-2xl lg:text-3xl', rule: 'h-[1.5px] lg:h-[2px]', gapTop: 'mt-3', gapTag: 'mt-2 sm:mt-3' },
    xl: { img: 'h-28 sm:h-36 lg:h-48', tag: 'text-xl sm:text-2xl lg:text-4xl', rule: 'h-[2px]', gapTop: 'mt-3 sm:mt-4', gapTag: 'mt-2 sm:mt-3' },
  };
  const s = sizes[size] || sizes.md;
  const tagColor = tone === 'light' ? 'text-[color:var(--tdt-ivory)]' : 'text-black';
  const filterStyle = dropShadow ? { filter: 'drop-shadow(0 2px 18px rgba(0,0,0,0.85))' } : undefined;
  const imgSrc = tone === 'light'
    ? '/assets/logos/logo-mark-only-on-dark.png'
    : '/assets/logos/logo-mark-only.png';

  return (
    <div className={`inline-flex flex-col items-center ${className}`}>
      <img
        src={imgSrc}
        alt="Tour de Taste"
        className={`${s.img} w-auto object-contain`}
        style={filterStyle}
      />
      <div className={`inline-flex flex-col items-stretch ${s.gapTag}`}>
        <div
          className={`${s.rule} rounded-full w-full`}
          style={{ backgroundColor: '#f5c518', ...filterStyle }}
        />
        <div
          className={`font-serif italic ${s.tag} ${s.gapTop} tracking-wide text-center whitespace-nowrap ${tagColor}`}
          style={{ ...filterStyle, fontWeight: 500 }}
        >
          Taste the World Differently
        </div>
      </div>
    </div>
  );
}

export default Logo;
